import { useLocation } from 'react-router';
import { HomePageSkeleton } from './HomePageSkeleton';
import { PageLoader } from './PageLoader';
import { isHomePagePath } from '../../util/homePagePaths';

/** Route-aware Suspense fallback — tall skeleton on homepage routes to avoid footer layout shift. */
export function RouteSuspenseFallback() {
    const { pathname } = useLocation();
    if (isHomePagePath(pathname)) {
        return <HomePageSkeleton />;
    }
    return <PageLoader />;
}
